import { FormControl, FormLabel, Input, VStack } from "@chakra-ui/react";
import React from "react";
import { brandPalette } from "../../constants/brandPalette";

const MainInput = ({
  label,
  error,
  placeholder,
  register,
  name,
  type = "text",
  defaultValues,
  required = true,
}) => {
  return (
    <FormControl isInvalid={Boolean(error)}>
      <VStack align="stretch" spacing={2}>
        {label && (
          <FormLabel
            m={0}
            htmlFor={name}
            fontSize="14px"
            fontWeight="700"
            color="var(--text-primary)"
            textAlign="left"
          >
            {label}
          </FormLabel>
        )}
        <Input
          id={name}
          type={type}
          borderColor={error ? "red" : "var(--border-subtle)"}
          placeholder={placeholder}
          size="md"
          bg="var(--surface-muted)"
          color="var(--text-primary)"
          border="1px solid"
          borderRadius="lg"
          _focus={{
            borderColor: brandPalette.primary,
            boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.22)",
          }}
          _placeholder={{ color: "var(--text-muted)" }}
          defaultValue={defaultValues}
          {...register(name, required ? { required: "هذه المعلومات مطلوبة" } : {})}
        />
      </VStack>
    </FormControl>
  );
};

export default MainInput;